import "bootstrap/dist/css/bootstrap.css"
import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

import "bootstrap/dist/js/bootstrap.js"